export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "create_your": "వేద జ్యోతిష్యం ",
    "dasha_phal": "ఆధారంగా మీ దశాఫలం రూపొందించబడుతుంది",
    "planetary_periods_analysis": "గ్రహ కాలాల విశ్లేషణ",
    "dasha_phal_description": "మీ వింశోత్తరి మహాదశా ప్రయాణం బలమైన కెరీర్ వృద్ధి, సంపద, గుర్తింపు మరియు సహాయక సంబంధాల దశలను చూపిస్తుంది, ముఖ్యంగా శుక్ర, సూర్య, చంద్ర, మంగళ, రాహు మరియు శని కాలాలలో ఇవి స్పష్టంగా కనిపిస్తాయి.",

    // Service Information
    "enter_birth_details": "మీ జన్మ వివరాలను నమోదు చేయండి",
    "complete_dasha_phal_analysis": "పూర్తి  దశా ఫల్ విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_dasha_analysis_note": "మీ జీవితాన్ని ప్రభావితం చేసే అన్ని ప్రధాన మరియు చిన్న గ్రహ కాలాల సమగ్ర విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_dasha": "ఖచ్చితమైన దశా గణనల కోసం సరైన జన్మ సమయం కీలకం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Features & Benefits
    "current_dasha_period_analysis": "ప్రస్తుత దశా కాల విశ్లేషణ",
    "planetary_influence_detailed": "వివరణాత్మక గ్రహ ప్రభావం",
    "future_dasha_predictions": "భవిష్యత్ దశా భవిష్యవాణులు",
    "career_and_finance_guidance": "కెరీర్ మరియు ఆర్థిక మార్గదర్శనం",
    "remedial_measures": "పరిహార చర్యలు",
    "pdf_download": "PDF డౌన్‌లోడ్",

    "what_you_get": "మీరు పొందేవి",
    "current_mahadasha_antardasha": "ప్రస్తుత మహాదశా మరియు అంతర్దశా",
    "planetary_effects_detailed": "వివరణాత్మక గ్రహ ప్రభావాలు",
    "timing_of_events": "ముఖ్యమైన సంఘటనల సమయం",
    "future_dasha_timeline": "భవిష్యత్ దశా కాలక్రమం",

    // Actions & Buttons
    "pay_and_generate_chart": "చెల్లించి విశ్లేషణ రూపొందించండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "అభ్యర్థనను ప్రాసెస్ చేస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "dasha_phal_analysis_processing": "మీ దశా ఫల్ విశ్లేషణ అభ్యర్థన అందుకోబడింది మరియు మా నిపుణ జ్యోతిష్యులచే ప్రాసెస్ చేయబడుతోంది.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "డెలివరీ సమయం",
    "within_12_hours_delivery_note": "మీ విశ్లేషణ 12 గంటలలోపు అందించబడుతుంది",
    "whatsapp_notification": "వాట్సాప్ నోటిఫికేషన్",
    "whatsapp_delivery_note": "మీరు వాట్సాప్‌లో అప్‌డేట్‌లను అందుకుంటారు",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీరు అందుకునేవి",
    "detailed_dasha_phal_report": "వివరణాత్మక దశా ఫల్ నివేదిక (PDF)",
    "current_planetary_periods": "ప్రస్తుత గ్రహ కాలాల విశ్లేషణ",
    "future_dasha_predictions_timeline": "భవిష్యత్ దశా భవిష్యవాణుల కాలక్రమం",
    "planetary_remedies_guidance": "గ్రహ పరిహారాలు మరియు మార్గదర్శనం",
    "career_finance_predictions": "కెరీర్ మరియు ఆర్థిక భవిష్యవాణులు",

    // Visual Content
    "sample_dasha_phal": "నమూనా దశా ఫల్ విశ్లేషణ",
    "sample_dasha_phal_description": "ఇది మీ వివరణాత్మక దశా ఫల్ విశ్లేషణ ఎలా ఉంటుందో చూపిస్తుంది",
    "major_planetary_periods": "ప్రధాన గ్రహ కాలాలు",

    // Planetary Periods
    "sun_dasha": "సూర్య దశా",
    "moon_dasha": "చంద్ర దశా", 
    "mars_dasha": "మంగళ దశా",
    "mercury_dasha": "బుధ దశా",
    "jupiter_dasha": "గురు దశా",
    "venus_dasha": "శుక్ర దశా",

    // Status & Processing
    "your_dasha_phal_analysis_status": "మీ దశా ఫల్ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ విశ్లేషణను ప్రాసెస్ చేస్తోంది",
    "analysis_processing_message": "మా నిపుణ జ్యోతిష్యులు మీ జన్మ కుండలి మరియు గ్రహ కాలాలను జాగ్రత్తగా విశ్లేషిస్తున్నారు.",
    "request_id": "అభ్యర్థన ID",
    "status": "స్థితి",
    "processing": "ప్రాసెసింగ్",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "ఇమెయిల్ నోటిఫికేషన్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్ త్వరలో వస్తుంది",
    "delivery_within_12_hours": "12 గంటలలోపు డెలివరీ",

    // Support & Contact
    "contact_support": "మద్దతును సంప్రదించండి",
    "need_help": "సహాయం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని ఫీల్డ్‌లను పూరించండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "ప్రాసెసింగ్ విఫలమైంది. దయచేసి మద్దతును సంప్రదించండి.",

    // Form Validation Messages
    "name_required": "పేరు అవసరం",
    "email_required": "ఇమెయిల్ అవసరం",
    "phone_required": "ఫోన్ నంబర్ అవసరం",
    "date_required": "జన్మ తేదీ అవసరం",
    "time_required": "జన్మ సమయం అవసరం",
    "place_required": "జన్మ స్థలం అవసరం"
}
